// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const XAxisTopBottomIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="XAxisTopBottomIcon" ref={forwardedRef} {...props}>
      <path d="M3 4.5h14V3.75a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z" />
      <path d="M3 7.5V6h1.5v1.5z" />
      <path d="M3 9.25v1.5h1.5v-1.5z" />
      <path d="M3 13.749v-1.5h1.5v1.5z" />
      <path d="M3 15.5h14v.75a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const XAxisTopBottomIcon = /* @__PURE__ */ Object.assign(
  XAxisTopBottomIconComponent,
  { displayName: 'XAxisTopBottomIcon' },
);
